<template>
  <v-card
    @click="modal = true"
    style="position:relative;"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :class="hover ? 'elevation-10 pointer' : 'elevation-3 pointer'"
  >
    <p
      :class="`${status.class} mb-0 py-1 text-xs-center font-weight-bold`"
      style="font-size:11px;text-transform:uppercase;"
    >
      {{ status.text }}
    </p>
    <div class="pa-3" style="position:relative;">
      <h6 class="primary--text">Solicitud de presupuesto</h6>
      <h3 class="font-weight-light" v-for="item in items" :key="item.id">
        {{item.service.name}} | {{item.description}}
      </h3>
      <h6 class="primary--text mt-2">Realizado el:</h6>
      <p class="mb-0 font-weight-light">
        {{ $moment(created).format('ddd DD MMM YYYY HH:mm') }}
      </p>
    </div>
    <div class="pa-3 primary white--text" style="position:relative;">
      <Estado :quotation="quoted"></Estado>
      <v-container grid-list-xs class="pa-0">
        <v-layout row wrap align-center fill-height>
          <v-flex xs4>
            <img
              id="logo"
              class="elevation-5"
              :src="
                institution.logo
                  ? institution.logo
                  : 'http://placehold.it/200x200'
              "
              alt=""
              style="max-width:100%;"
            />
          </v-flex>
          <v-flex xs8 class="px-0 white--text">
            <h6 class="font-weight-light">Solicitud a</h6>
            <h4>{{ institution.name }}</h4>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-dialog v-model="modal" :max-width="status.width" lazy>
      <v-card>
        <template v-if="status.state === 0 && !!quotation">
          <v-card-text>
            <iframe
              :src="quotation.preview"
              style="border:none;width:100%;min-height:400px;"
            ></iframe>
          </v-card-text>
        </template>
        <template v-if="status.state === 1">
          <div class="pa-5 text-xs-center">
            <img src="@/assets/img/we-help-en-espera.png" alt="" />
            <h2 class="headline mt-4 font-weight-light">
              Esta solicitud se encuentra en espera de presupuesto
            </h2>
          </div>
        </template>
        <template v-if="status.state === 2">
          <div class="pa-5 text-xs-center">
            <!-- <img src="http://placehold.it/300x300" alt="" /> -->
            <h2 class="headline mt-4 font-weight-light">Este presupuesto ha expirado</h2>
            <p class="mb-0 font-weight-light">
              el {{ $moment(quotation.expires_at).format('ddd DD MMM YYYY HH:mm') }}
            </p>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    institution: {
      type: Object,
      default: () => {}
    },
    quoted: {
      type: Boolean,
      default: false
    },
    quotation: {
      type: Object,
      default: () => {}
    },
    created: {
      type: String
    }
  },
  components: {
    Estado: () => import('@/components/panel-data/Estado')
  },
  data() {
    return {
      hover: false,
      modal: false
    }
  },
  computed: {
    status() {
      if (this.quoted) {
        // const today = this.$moment()
        // const date = this.$moment(this.quotation.expires_at)
        // const diff = date.diff(today, 'days')
        // if (diff > 0)
          return {
            state: 0,
            text: 'Presupuesto Recibido',
            class: 'green white--text',
            width: '800px'
          }
        // return {
        //     state: 2,
        //     text: 'Promoción no Vigente',
        //     class: 'grey lighten-2',
        //     width: '500px'
        //   }
      } 
      return {
        state: 1,
        text: 'En Espera de Presupuesto',
        class: 'grey lighten-2',
        width: '500px'
      }
    }
  }
}
</script>
<style scoped>
#logo {
  max-width: 100%;
  width: 60px;
  border-radius: 100%;
  display: block;
  margin: 0 auto;
}
.pointer {
  cursor: pointer;
}
</style>